export default __webpack_public_path__ + "static/media/homebanner1.2f6e13ea.jpg";